module.exports = __webpack_public_path__ + "static/media/tab.52d15cc9.png";